import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t", "\n\t"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t", "\n\t"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tjustify-content: center;\n\tmin-width: 18px;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: 4px 0;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmax-width: 120px;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: ", ";\n\tbox-shadow: 0 0 0 1px ", " inset;\n\tcursor: default;\n\tdisplay: flex;\n\theight: 18px;\n\tline-height: 1;\n\tpadding: 0 4px;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, getBackgroundColor, getBackgroundColorText, styled, ui } from '@wp-g2/styles';
export var BadgeView = styled.div(_templateObject(), ui.get('controlBorderRadius'), ui.get('surfaceBorderColor'));
export var truncate = css(_templateObject2());
export var text = css(_templateObject3());
export var rounded = css(_templateObject4(), ui.borderRadius.circle);
export function getBackground(_ref) {
  var color = _ref.color,
      isBold = _ref.isBold;
  return css(_templateObject5(), getBackgroundColor(color, {
    isBold: isBold
  }));
}
export function getBackgroundText(_ref2) {
  var color = _ref2.color,
      isBold = _ref2.isBold;
  return css(_templateObject6(), getBackgroundColorText(color, {
    isBold: isBold
  }));
}